<template>
  <!-- <vue-pickers
    ref="address"
    :data="pickData"
    :default-index="defaultIndex"
    :show-toolbar="true"
    :mask-click="false"
    :visible.sync="popupShow"
    title="请选择地区"
    :layer="3"
    :link="true"
    :row-number="5"
    :cancel-text="$t('bigEvent.info.text59_1[2]')"
    :confirm-text="$t('bigEvent.info.text59_1[1]')"
    @cancel="cancel"
    @confirm="confirm"
    @change="change"
  /> -->

  <van-popup v-model:show="popupShow" round position="bottom">
    <van-picker
      ref="address"
      show-toolbar
      :columns="pickData"
      value-key="label"
      :cancel-button-text="$tm('bigEvent.info.text59_1[2]')"
      :confirm-button-text="$tm('bigEvent.info.text59_1[1]')"
      @cancel="cancel"
      @confirm="confirm"
    />
  </van-popup>

</template>

<script>
// import vuePickers from 'vue-pickers'
const retArr = []
let pointer = 0
export default {
  name: 'AddressList',
  // components: { vuePickers },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popupShow: false,
      pickData: [],
      result: [],
      defaultIndex: [],
      fieldNames: {
        text: 'label',
        value: 'id',
        children: 'children'
      },
      fieldValue: '',
      show: false
    }
  },
  watch: {
    isShow: {
      handler(newVal, oldVal) {
        this.popupShow = newVal
      },
      immediate: true
    }
    // showBack: {
    //   handler(newVal, oldVal) {
    //     this.defaultIndex = newVal
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.getAreaData()
  },
  methods: {
    onFinish({ selectedOptions }) {
      this.popupShow = false
      this.fieldValue = selectedOptions.map((option) => option.text).join('/')
    },
    checkVal(addressArr, pointerArr) {
      const self = this
      console.table({ '几层': pointer })
      addressArr && addressArr.forEach((item, i) => {
        if (item.id === pointerArr[pointer]) {
          retArr.push(i)
          console.table({ '几层': pointer, '所在索引': i, retArr })
          if (item.children && pointer < pointerArr.length) {
            pointer += 1
            console.log('子元素下表', i, pointer, item.children)
            self.checkVal(item.children, pointerArr)
          }
        }
      })
      console.log('要返回的数据格式', retArr)
      return retArr
    },
    getAreaData() {
      fetch(`https://static.mingchu.co/address.json`, {
        headers: { 'Content-Type': 'application/json' }})
        .then(response => response.json())
        .then(data => {
          this.pickData = data.data
          console.log('地址的数据', data.data)
          this.defaultIndex = this.checkVal(data.data, this.showBack)
        })
        .catch(err => { console.log(err) })
    },
    cancel() {
      console.log('cancel')
      this.popupShow = false
      this.$emit('getAddressShow', false)
    },
    confirm([item1, item2 = {}, item3 = {}]) {
      console.log(item1, item2, item3)
      let arr = []
      if (item1.label === '中国大陆') {
        arr = [item1, item2, item3]
      } else if (item1.label === '台湾地区' || item1.label === '中国香港' || item1.label === '中国澳门') {
        arr = [item1, item2, []]
      } else {
        arr = [item1, [], []]
      }

      this.result = arr
      this.$emit('getAddress', arr)
      this.$emit('getAddressShow', false)
      this.popupShow = false
    },
    change(val) {
      console.log('change', val)
    }
  }
}
</script>

<style lang="scss">
  .vue-picker{
    .left,.right{
      .btn{color: #C99700;}
    }
  }
</style>
